import { render, staticRenderFns } from "./deleted_services.vue?vue&type=template&id=663c32e5&scoped=true&"
import script from "./deleted_services.vue?vue&type=script&lang=js&"
export * from "./deleted_services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c32e5",
  null
  
)

export default component.exports